import * as actionTypes from '../action-types';
import { toaster } from '../../services/toast-service';
import { getAPI, paypalPayment, payuPayment, postAPI, razorpayPayment } from '../../utils/api-function';
import { call, put, select, takeLeading } from 'redux-saga/effects';
import { add_product_to_cart, book_pitr_paksha, book_product_cart, book_puja, book_yatra, get_product, get_product_cart, get_product_category, get_puja, get_yatra, get_yatra_details, update_product_cart } from '../../utils/api-routes';

//! Yatra
function* getYatra() {
    try {
        const { data } = yield getAPI({ url: get_yatra });
        console.log("Get Yatra Saga Response ::: ", data);
        if (data?.status) {
            yield put({ type: actionTypes.SET_YATRA, payload: data?.data });
        }
    } catch (error) {
        console.log("Get Yatra Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_YATRA, payload: [] });
    }
};

function* getYatraDetails(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield postAPI({ url: get_yatra_details, payload });
        console.log("Yatra Details Saga Response ::: ", data);
        if (data?.status) {
            yield put({ type: actionTypes.SET_YATRA_DETAILS, payload: data?.data });
        }
    } catch (error) {
        console.log("Get Yatra Details Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_YATRA_DETAILS, payload: {} });
    }
};

function* bookYatra(action) {
    try {
        const { payload } = action;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);
        const _yName = [customerDetails?.firstname, customerDetails?.lastname].filter(Boolean).join(' ') || customerDetails?.mobile || 'Customer';
        try { localStorage.setItem('bd_pending_redirect', '/history/yatra-history'); } catch (_) {}
        const res = yield payuPayment({
            amount: payload?.data?.totalPrice,
            service: 'yatra',
            bookingType: 'yatra',
            bookingData: payload?.data,
            name: _yName,
            email: customerDetails?.email || '',
            contact: customerDetails?.mobile || '',
        });
        if (!res?.status) toaster?.error({ text: 'Payment could not be initiated.' });
    } catch (error) {
        toaster?.error({ text: error?.response?.data?.message || 'Booking failed.' });
    }
};

//! Product
function* getProductCategory() {
    try {
        const { data } = yield getAPI({ url: get_product_category });
        console.log("Get Product Category Saga Response ::: ", data);
        if (data?.success) {
            yield put({ type: actionTypes.SET_PRODUCT_CATEGORY, payload: data?.productCategory });
        }
    } catch (error) {
        console.log("Get Product Category Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PRODUCT_CATEGORY, payload: [] });
    }
};

function* getProduct(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield postAPI({ url: get_product, payload });
        console.log("Get Product Saga Response ::: ", data);
        if (data?.success) {
            yield put({ type: actionTypes.SET_PRODUCT, payload: data?.products });
        }
    } catch (error) {
        console.log("Get Product Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PRODUCT, payload: [] });
    }
};

function* addProductToCart(action) {
    try {
        const { payload } = action;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);
        const customerId = payload?.customerId || customerDetails?.userid;

        if (!customerId) {
            toaster.info({ text: 'Please login to add items to cart' });
            return;
        }
        if (!payload?.productId) {
            toaster.info({ text: 'Invalid product' });
            return;
        }

        const finalPayload = { productId: payload.productId, customerId };
        console.log("AddToCart Payload :::", finalPayload);

        const { data } = yield postAPI({ url: add_product_to_cart, payload: finalPayload });
        console.log("Add Product To Cart Saga Response ::: ", data);

        if (data?.success) {
            toaster.success({ text: data?.message || 'Added to cart' })
            yield put({ type: actionTypes.GET_PRODUCT_CART, payload: null });
        } else {
            toaster.info({ text: data?.message || 'Failed to add to cart' });
        }

    } catch (error) {
        console.log("Add Product To Cart Saga Error ::: ", error);
        toaster.info({ text: error?.response?.data?.message || error?.message || 'Failed to add to cart' });
    }
};

function* updateProductCart(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);

        const { data } = yield postAPI({ url: update_product_cart, payload });
        console.log("Update Product Cart Saga Response ::: ", data);

        if (data?.success) {
            toaster.success({ text: data?.message })
            yield put({ type: actionTypes.GET_PRODUCT_CART, payload: null });
        } else {
            toaster.info({ text: data?.message });
        }

    } catch (error) {
        toaster.info({ text: error?.response?.data?.message });
        console.log("Update Product Cart Saga Error ::: ", error);
    }
};

function* getProductCart(action) {
    try {
        const { payload } = action;
        console.log("Payload :::", payload);
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        const { data } = yield postAPI({ url: get_product_cart, payload: { customerId: customerDetails?.userid } });
        console.log("Get Product Cart Saga Response ::: ", data);
        if (data?.success) {
            yield put({ type: actionTypes.SET_PRODUCT_CART, payload: { total_price: data?.totalPrice, data: data?.cart } });
        }

    } catch (error) {
        console.log("Get Product Cart Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PRODUCT_CART, payload: [] });
    }
};

function* bookProductCart(action) {
    try {
        const { payload } = action;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);
        console.log("Name ::: ", customerDetails?.firstname + ' ' + customerDetails?.lastname);

        const _pcName = [customerDetails?.firstname, customerDetails?.lastname].filter(Boolean).join(' ') || customerDetails?.mobile || 'Customer';
        const razorpayResponse = yield razorpayPayment({ amount: payload?.amount, name: _pcName, email: customerDetails?.email || '', contact: customerDetails?.mobile || '' })
        // console.log("Razor Pay Response ::: ", razorpayResponse);

        if (razorpayResponse?.status) {
            const { data } = yield postAPI({ key: 'Web', url: book_product_cart, payload: { ...payload?.data, customerName: _pcName } });
            // const { data } = yield postAPI({ key: 'Web', url: book_product_cart, payload: { ...payload?.data, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, razorpayPaymentId: razorpayResponse?.result?.razorpay_payment_id, razorpaySignature: razorpayResponse?.result?.razorpay_signature } });
            console.log("Book Puja Data Response :: ", data);
            if (data?.success) {
                toaster.success({ text: data?.message });
                yield call(payload?.onComplete)
            }

        } else {
            toaster?.error({ text: 'Payment Failed.' });
        }

    } catch (error) {
        toaster?.error({ text: error?.response?.data?.message });
    }
};

//! Puja
function* getPuja() {
    try {
        const { data } = yield getAPI({ url: get_puja });
        console.log("Get Puja Saga Response ::: ", data);
        if (data?.success) {
            yield put({ type: actionTypes.SET_PUJA, payload: data?.pooja });
        }
    } catch (error) {
        console.log("Get Puja Saga Error ::: ", error);
        yield put({ type: actionTypes.SET_PUJA, payload: [] });
    }
};

function* bookPuja(action) {
    try {
        const { payload } = action;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);
        const _pjName = [customerDetails?.firstname, customerDetails?.lastname].filter(Boolean).join(' ') || customerDetails?.mobile || 'Customer';
        const isPayPal = payload?.data?.gateway === 'paypal' || payload?.data?.paymentGateway === 'paypal' || payload?.data?.currency === 'USD';

        if (isPayPal) {
            let paymentId = payload?.data?.paymentId;

            // If payment was not already completed prior to dispatch, trigger paypalPayment
            if (!paymentId) {
                const paypalRes = yield call(paypalPayment, {
                    amount: payload?.data?.amount,
                    name: payload?.data?.customerName || _pjName,
                    email: payload?.data?.customerEmail || customerDetails?.email || '',
                    contact: payload?.data?.customerPhone || customerDetails?.mobile || '',
                });

                if (paypalRes?.status) {
                    paymentId = paypalRes?.result?.paymentId || paypalRes?.result?.paypal_order_id;
                } else {
                    toaster?.error({ text: paypalRes?.message || 'PayPal payment was cancelled or failed.' });
                    return;
                }
            }

            // Record completed booking with PayPal details
            const { data } = yield postAPI({
                url: book_puja,
                payload: {
                    ...payload?.data,
                    paymentId,
                    gateway: 'paypal',
                    paymentGateway: 'paypal',
                    paymentStatus: 'SUCCESS',
                }
            });

            if (data?.success) {
                toaster.success({ text: data?.message || 'Puja booked successfully!' });
                yield call(payload?.onComplete);
            } else {
                toaster.error({ text: data?.message || 'Failed to confirm booking after payment.' });
            }
        } else {
            // Default PayU flow for India
            try { localStorage.setItem('bd_pending_redirect', '/history/puja-history'); } catch (_) {}
            const res = yield payuPayment({
                amount: payload?.data?.amount,
                service: 'puja',
                bookingType: 'puja',
                bookingData: payload?.data,
                name: _pjName,
                email: customerDetails?.email || '',
                contact: customerDetails?.mobile || '',
            });
            if (!res?.status) toaster?.error({ text: 'Payment could not be initiated.' });
        }
    } catch (error) {
        toaster?.error({ text: error?.response?.data?.message || 'Booking failed.' });
    }
};

//! Pitr Paksha
function* bookPitrPaksha(action) {
    try {
        const { payload } = action;
        const customerDetails = yield select(state => state?.authReducer?.customerDetails);

        if (payload?.data?.country === 'India') {
            const razorpayResponse = yield razorpayPayment({ amount: payload?.data?.amount, name: payload?.data?.customerName, contact: payload?.data?.mobile })

            if (razorpayResponse?.status) {
                const { data } = yield postAPI({ key: 'Web', url: book_pitr_paksha, payload: { ...payload?.data, paymentId: razorpayResponse?.result?.razorpay_payment_id, razorpayOrderId: razorpayResponse?.result?.razorpay_order_id, razorpayPaymentId: razorpayResponse?.result?.razorpay_payment_id, razorpaySignature: razorpayResponse?.result?.razorpay_signature } });
                console.log("Book Pitr Paksha Data Response :: ", data);
                if (data?.success) {
                    toaster.success({ text: data?.message });
                    yield call(payload?.onComplete)
                }
            } else {
                toaster?.error({ text: razorpayResponse?.message || 'Payment Failed.' });
            }
        } else {
            const { data } = yield call(postAPI, { key: 'Web', url: 'api/app/customer/book_pitra_puja_with_paypal', payload: payload?.data });

            if (data?.success) {
                toaster.success({ text: data?.message });
                yield call(payload?.onComplete);
            } else {
                toaster.error({ text: 'Booking failed.' });
            }
        }
    } catch (error) {
        toaster.error({ text: error?.response?.data?.message || 'Something went wrong.' });
    }
};

export default function* ecommerceSaga() {
    //! Yatra
    yield takeLeading(actionTypes.GET_YATRA, getYatra);
    yield takeLeading(actionTypes.GET_YATRA_DETAILS, getYatraDetails);
    yield takeLeading(actionTypes.BOOK_YATRA, bookYatra);

    //! Product
    yield takeLeading(actionTypes.GET_PRODUCT_CATEGORY, getProductCategory);
    yield takeLeading(actionTypes.GET_PRODUCT, getProduct);
    yield takeLeading(actionTypes.ADD_PRODUCT_TO_CART, addProductToCart);
    yield takeLeading(actionTypes.UPDATE_PRODUCT_CART, updateProductCart);
    yield takeLeading(actionTypes.GET_PRODUCT_CART, getProductCart);
    yield takeLeading(actionTypes.BOOK_PRODUCT_CART, bookProductCart);
    yield takeLeading(actionTypes.BOOK_PITR_PAKSHA, bookPitrPaksha);

    //! Puja
    yield takeLeading(actionTypes.GET_PUJA, getPuja);
    yield takeLeading(actionTypes.BOOK_PUJA, bookPuja);
};